import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import ResearchSubmissionPage from 'buyside/components/presentation/ResearchSubmissionPage/researchSubmissionPage';

import { NEW_RESEARCH_ROUTES } from 'buyside/util/urlHelper';

const ResearchSubmissionPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="research submission page root">
      <Router basename={NEW_RESEARCH_ROUTES.BASE}>
        <ResearchSubmissionPage />
      </Router>
    </ErrorBoundary>
  );
};

export default ResearchSubmissionPageRoot;
